// React Query hook for the settings audit log page.

import { useQuery } from '@tanstack/react-query';
import { listAuditLog, type AuditLogFilters } from '../../../../../api/auditLog';
import { queryKeys } from '../../../../../api/queryKeys';
import type { ActivityLogListResponse } from '../../../../../types/api';

export function useAuditLog(filters: AuditLogFilters) {
  return useQuery<ActivityLogListResponse>({
    queryKey: queryKeys.activityLog.list(
      filters as unknown as Record<string, unknown>,
    ),
    queryFn: () => listAuditLog(filters),
    staleTime: 30_000,
  });
}
